module.exports = __webpack_public_path__ + "28b67065/img/product-icon-grey.b248963c.svg";